import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=681a77b3&scoped=true&lang=pug"
import script from "./QuotationList.vue?vue&type=script&lang=js"
export * from "./QuotationList.vue?vue&type=script&lang=js"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=681a77b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a77b3",
  null
  
)

export default component.exports